import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Award, Clock, Globe2, Lock, MessageCircle, ShieldCheck } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { WHATSAPP } from "../../lib/api";
import { Item, Reveal, Stagger } from "../Reveal";

const LIBRARY_IMG = "https://images.unsplash.com/photo-1741795822013-570c944ac5bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const SectionHead = ({ kicker, title, sub, action }) => (
  <Reveal className="section-head">
    <div><span className="kicker">{kicker}</span><h2>{title}</h2>{sub && <p>{sub}</p>}</div>
    {action}
  </Reveal>
);

const icons = [ShieldCheck, Globe2, Award, Clock, Lock, MessageCircle];

export const Why = () => {
  const { t } = useLang();
  return (
    <section className="section" id="why" data-testid="why-section">
      <div className="container why">
        <Reveal className="why-visual"><img src={LIBRARY_IMG} alt="library" loading="lazy" /><div className="why-caption"><span>RESEARCHNETWORK / 2026</span><b>{t.why.caption}</b></div></Reveal>
        <div>
          <Reveal><span className="kicker">{t.why.kicker}</span><h2 style={{ fontSize: "clamp(1.7rem,3vw,2.4rem)", marginTop: 14, fontWeight: 800, lineHeight: 1.3 }}>{t.why.title}</h2><p className="muted" style={{ marginTop: 12, lineHeight: 1.8 }}>{t.why.sub}</p></Reveal>
          <Stagger className="why-list" stagger={0.08}>
            {t.why.items.map(([title, text], i) => { const I = icons[i]; return <Item className="why-item" key={title}><span className="wi"><I size={18} /></span><div><b>{title}</b><small>{text}</small></div></Item>; })}
          </Stagger>
        </div>
      </div>
    </section>
  );
};

export const Steps = () => {
  const { t } = useLang();
  return (
    <section className="section" style={{ paddingTop: 0 }} data-testid="steps-section">
      <div className="container">
        <SectionHead kicker={t.steps.kicker} title={t.steps.title} />
        <Stagger className="steps">
          {t.steps.items.map(([title, text], i) => <Item className="step" key={title}><span className="num">0{i + 1}</span><h3>{title}</h3><p>{text}</p></Item>)}
        </Stagger>
      </div>
    </section>
  );
};

export const Journals = () => {
  const { t } = useLang();
  const list = ["Scopus", "PubMed", "PMC", "Web of Science", "Embase", "DOAJ", "Cochrane Library", "EBSCO", "Google Scholar", "Ovid", "BMJ"];
  return (
    <section className="section" style={{ paddingTop: 0 }} data-testid="journals-section">
      <div className="container">
        <Reveal style={{ textAlign: "center", marginBottom: 32 }}><span className="kicker" style={{ justifyContent: "center" }}>{t.journals.kicker}</span><h2 style={{ fontSize: "clamp(1.5rem,2.6vw,2.1rem)", marginTop: 12, fontWeight: 800 }}>{t.journals.title}</h2></Reveal>
        <Stagger className="journals" stagger={0.05}>{list.map((j) => <Item className="journal" key={j}>{j}</Item>)}</Stagger>
      </div>
    </section>
  );
};

export const CTA = () => {
  const { t, rtl } = useLang();
  const Arrow = rtl ? ArrowLeft : ArrowRight;
  return (
    <section className="cta" data-testid="cta-section">
      <div className="container">
        <Reveal><span className="kicker" style={{ justifyContent: "center" }}>{t.cta.kicker}</span><h2>{t.cta.title}</h2><p>{t.cta.sub}</p>
          <div className="hero-actions"><Link to="/opportunities" className="btn btn-primary" data-testid="cta-browse-button">{t.cta.button}<Arrow size={18} /></Link><a href={WHATSAPP} target="_blank" rel="noreferrer" className="btn btn-whatsapp" data-testid="cta-whatsapp-button"><MessageCircle size={18} />{t.cta.wa}</a></div>
        </Reveal>
      </div>
    </section>
  );
};
